/** GraphQL selection for price list dropdowns (the fields any signed-in user may read). */
export const PRICE_LIST_DROPDOWN_QUERY = `
  id
  entityId
  name
  code
  rateBasis
  type
  enabled
`;
